export const siteSettings = {
  name: "Prime Alliance",
  link: "https://primealliancepro.com",
  email: "support@primealliancepro.com",
  appLink: "https://app.primealliancepro.com",
};
